import IParamTypeDescriptor from "./IParamTypeDescriptor";

/**
 * Interface for the ParamScripts rule. This must be in sync with the backend: "db.php"
 */
interface IParamScript {
    id: string;
    productId: string;
    typeDescriptor: IParamTypeDescriptor;
    tab: string;
    title: string;
    panel: string | null;
    sortIndex: number;
    applyIndex: number | null;
    editable: number;
    targetPath: string | null;
    targetType: string | null;
    parameterName: string;
    parameterType: string | null;
    parameterProperty: string;
    parameterPropertyIndex: number | null;
    composite: number;
    parameterValue: any;
    defaultValue?: any;
    shopId: number | null;
    customerId: number | null;
    cartId: number | null;
}

export default IParamScript;
